import { createSlice } from "@reduxjs/toolkit";
import { shippingPartnerApiSlice } from "./shippingPartnerApiSlice";

export const initialState = {
  all: {
    data: [],
    size: 10,
    totalData: 0,
    page: 1,
  },
  one: {
    name: "",
    contact_person: "",
    // shippingPartner_code: '',
    order: 0,
    logic_code: "",
    is_active: false,
  },
  query: { size: 10, find_name: "", find_logic_code: "" },
  loading: false,
  errors: {},
  chosen_shippingPartner: [],
};

export const shippingPartnerSlice = createSlice({
  name: "shippingPartner",
  initialState,
  reducers: {
    setOneValue: (state, action) => {
      state.one[action.payload.key] = action.payload.value;
    },
    setQueryValue: (state, action) => {
      state.query[action.payload.key] = action.payload.value;
    },
    clearQuery: (state, action) => {
      state.query = initialState.query;
    },
    clearOne: (state, action) => {
      state.one = initialState.one;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      shippingPartnerApiSlice.endpoints.loadOneShippingPartner.matchFulfilled,
      (state, { payload }) => {
        state.one = payload.data;
      }
    );
  },
});

export const { setOneValue, setQueryValue, clearQuery, clearOne } =
  shippingPartnerSlice.actions;

export default shippingPartnerSlice.reducer;
